
const Project = ({ project }) => {
  const { link, projectName, img } = project;
  return (
    <a rel="noreferrer" target="_blank" href={link}>
      <div>
        <img src={img} className=" rounded-lg" alt="" />
        <p className="capitalize font-bold">{projectName}</p>
      </div>
    </a>
  );
};

export default Project;
